import { render, staticRenderFns } from "./TotalizadorComercial.vue?vue&type=template&id=018f1714&"
import script from "./TotalizadorComercial.vue?vue&type=script&lang=js&"
export * from "./TotalizadorComercial.vue?vue&type=script&lang=js&"
import style0 from "./TotalizadorComercial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports